import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const levelLabel = (l) =>
    l == 1 ? "Beginner" : l == 2 ? "Intermediate" : l == 3 ? "Advanced" : "General";

const levelColor = (l) =>
    l == 1 ? "bg-emerald-50 text-emerald-700 border-emerald-200" :
    l == 2 ? "bg-amber-50 text-amber-700 border-amber-200" :
    l == 3 ? "bg-red-50 text-red-700 border-red-200" :
             "bg-slate-50 text-slate-600 border-slate-200";

function CourseCard({ typeclass, shortid, class_name, level, bg, classdata, setsection, setSelectedClass, course, role = 'teacher', setdashboard, setshortid }) {
    const navigate = useNavigate();
    const backgroundUrl = `${process.env.PUBLIC_URL}/bgimg${parseInt(bg) || 1}.png`;

    const handleCardClick = () => {
        if (role === "student") {
            navigate(`/main/sat/${shortid}`);
        } else {
            setsection(0);
            setSelectedClass(course);
        }
    };

    return (
        <div
            onClick={handleCardClick}
            className="group bg-white border border-slate-200 rounded-xl overflow-hidden cursor-pointer shadow-sm hover:shadow-md transition-all duration-200"
        >
            {/* Cover image */}
            <div className="relative h-32 w-full bg-cover bg-center" style={{ backgroundImage: `url(${backgroundUrl})` }}>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />
                {/* Type badge */}
                <span className="absolute top-2.5 right-2.5 text-[10px] font-bold uppercase tracking-wider bg-white/90 text-slate-700 px-2 py-0.5 rounded-full">
                    {typeclass || "—"}
                </span>
                {/* Level badge */}
                <span className={`absolute bottom-2.5 left-2.5 text-[10px] font-semibold px-2 py-0.5 rounded-full border ${levelColor(level)}`}>
                    {levelLabel(level)}
                </span>
            </div>

            {/* Info */}
            <div className="px-4 py-3">
                <h3 className="text-sm font-bold text-slate-800 truncate mb-2">{class_name}</h3>
                <div className="flex items-center justify-between">
                    <p className="text-xs text-slate-400 font-mono">
                        Code: <span className="font-semibold text-slate-600">{shortid}</span>
                    </p>
                    <FiArrowRight size={13} className="text-slate-300 group-hover:text-blue-500 group-hover:translate-x-0.5 transition-all" />
                </div>
            </div>
        </div>
    );
}

export default CourseCard;
